var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{ref:"canvas"},[_c('p',{staticClass:"text-center text-muted fs-17"},[_vm._v("No se pudo cargar el gráfico")])])])}
var staticRenderFns = []

export { render, staticRenderFns }